const DEFAULT_LOGOUT_REDIRECT_URL = 'https://creately.com/';
const LOGOUT_REDIRECT_STARTED_AT_KEY = 'creately.logoutRedirectStartedAt';
const LOGOUT_REDIRECT_PENDING_MS = 15000;
// Keep this document fenced until navigation, even when SSO is slow. The
// storage timeout only applies when a later page load inherits the marker.
let logoutStartedInThisDocument = false;

export function getLogoutRedirectUrl(): string {
  const siteUrl = import.meta.env.VITE_SITE_URL as string | undefined;
  const targetUrl = siteUrl || DEFAULT_LOGOUT_REDIRECT_URL;

  try {
    return new URL(targetUrl).toString();
  } catch {
    return DEFAULT_LOGOUT_REDIRECT_URL;
  }
}

export function markLogoutRedirectPending(): void {
  logoutStartedInThisDocument = true;
  try {
    window.sessionStorage.setItem(LOGOUT_REDIRECT_STARTED_AT_KEY, Date.now().toString());
  } catch {}
}

export function isLogoutRedirectPending(): boolean {
  if (logoutStartedInThisDocument) return true;
  try {
    const startedAt = Number(window.sessionStorage.getItem(LOGOUT_REDIRECT_STARTED_AT_KEY));
    return Number.isFinite(startedAt) && Date.now() - startedAt < LOGOUT_REDIRECT_PENDING_MS;
  } catch {
    return false;
  }
}

export function redirectToLogoutUrl(preferTopWindow = false): void {
  const redirectUrl = getLogoutRedirectUrl();

  if (preferTopWindow) {
    try {
      if (window.top && window.top !== window.self) {
        window.top.location.href = redirectUrl;
        return;
      }
    } catch {}
  }

  window.location.href = redirectUrl;
}
